var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-loader',{attrs:{"loading":_vm.loadingData}},[_c('div',{staticClass:"view-container"},[_c('maintenance-transactions-table',{attrs:{"header":_vm.tableHeader,"data":_vm.transactions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }